/**
 * Nimmt einem Zahlenfeld den Fokus, sobald das Mausrad ueber ihm dreht, solange es den Fokus hat.
 *
 * Chrome und Edge zaehlen den Wert eines fokussierten `<input type="number">` hoch oder runter, wenn
 * man ueber ihm scrollt. Wer eine Menge oder einen Preis eintippt und danach die Seite
 * weiterscrollt, waehrend der Zeiger noch auf dem Feld steht, aendert ihn still: aus 12,50 werden
 * 12,47, und nichts weist darauf hin. Firefox und Safari tun das nicht.
 *
 * Gezaehlt wird nur an einem fokussierten Feld, und erst in der Standardbehandlung NACH dem
 * Ereignis. Wer den Fokus vorher nimmt (Listener in der Capture-Phase am Dokument), laesst den Wert
 * stehen, und die Seite scrollt normal weiter. Bewusst nicht `preventDefault()`: das hielte auch
 * das Scrollen der Seite an.
 */
export function zahlenfeldOhneMausrad(event: Event): void {
  const feld = event.target
  if (feld instanceof HTMLInputElement && feld.type === 'number' && feld === feld.ownerDocument.activeElement) {
    feld.blur()
  }
}
